var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 300",
    style: {
      enableBackground: "new 0 0 355.4 279.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.7,
    y1: -692.1342,
    x2: 320.1,
    y2: -692.1342,
    gradientTransform: "matrix(1 0 0 -1 0 -564.6341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M309.4,25.3h-267c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272 c3.1,0,5.7-2.5,5.7-5.7V35.9C320,30.1,315.3,25.3,309.4,25.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "305,53.4 46.5,53.4 46.5,53.4 46.5,40.6 305,40.6 305,40.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M46.5,62.7v150.2c0,1.6,1.3,3,3,3H302c1.6,0,3-1.3,3-3V64.1c0-0.7-0.6-1.3-1.3-1.3L46.5,62.7 L46.5,62.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M299.1,47c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S299.1,45.3,299.1,47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032637008005136611920000012790042178122297483_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.9,
    y1: -802.7841,
    x2: 335.7,
    y2: -802.7841,
    gradientTransform: "matrix(1 0 0 -1 0 -564.6341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032637008005136611920000012790042178122297483_)"
    },
    d: "M330,229.7H21.7c-3.2,0-5.8,2.5-5.8,5.7 v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C335.7,232.2,333.2,229.7,330,229.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.4,
    y: 85.9,
    style: {
      fill: "#293657"
    },
    width: 211.6,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4,
    y: 105.8,
    style: {
      fill: "#293657"
    },
    width: 211.6,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 125.6,
    style: {
      fill: "#293657"
    },
    width: 211.6,
    height: 9
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 143.8,
    transform: "matrix(1 -1.056504e-03 1.056504e-03 1 -0.1566 0.1864)",
    style: {
      fill: "#293657"
    },
    width: 213.7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 163.6,
    transform: "matrix(1 -1.056595e-03 1.056595e-03 1 -0.1775 0.1864)",
    style: {
      fill: "#293657"
    },
    width: 213.7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 183.5,
    transform: "matrix(1 -1.056595e-03 1.056595e-03 1 -0.1985 0.1864)",
    style: {
      fill: "#293657"
    },
    width: 213.7,
    height: 9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4566"
    },
    d: "M142.2,68.9c0,28.6-23.1,51.7-51.7,51.7c-7.9,0-15.4-1.7-22-4.9c-0.2-0.2-0.4-0.2-0.9-0.4 C50.5,107,38.5,89.2,38.5,68.7C38.5,40.1,61.6,17,90.2,17c18.2,0,34,9.2,43.2,23.3c0,0.2,0.2,0.2,0.2,0.4 C139.2,48.9,142.2,58.5,142.2,68.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100376042596723808420000015307329477490028735_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5608,
    y1: 937.7914,
    x2: 89.5598,
    y2: 937.7914,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#F7AA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F46B45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100376042596723808420000015307329477490028735_)"
    },
    d: "M78.1,60.6L78.1,60.6 c-2.4-1.5-4.9-2.8-7.7-3.4c-7.5-1.9-15-0.4-20.7,3.6l0,0c-0.9,0.6-1.9,1.3-2.8,2.1c-3.6,3.2-6.2,7.5-7.5,12.4 c-3.4,13.7,4.7,27.6,18.4,31c2.4,0.6,4.9,0.9,7.3,0.9c0,0,0,0,0.2,0c0.4,0,1.1,0,1.5,0l0,0c9.8-0.9,18.4-7.5,21.6-17.3 c0,0,0,0,0-0.2c0.2-0.4,0.2-1.1,0.4-1.5c0-0.2,0-0.4,0.2-0.6C91.4,77.1,86.7,66.4,78.1,60.6z M69.6,60.8 c1.7,0.4,3.4,1.1,4.9,1.9l-8.1,9.4c-1.5,1.7-4.3,1.9-6,0.2l-8.1-8.5C57.2,60.4,63.4,59.1,69.6,60.8z M43.1,76.4 c1.1-4.1,3-7.5,5.8-10l6.2,10.5c1.3,2.1,0.4,4.7-1.7,5.8l-10.3,4.7C42,83.7,42,80.1,43.1,76.4z M58.7,102.9 c-6.6-1.7-11.5-6.2-14.3-11.8l10.9-3c2.4-0.6,4.7,0.9,5.1,3.2l2.4,12.4C61.2,103.6,59.9,103.4,58.7,102.9z M62.7,86.7 c-2.8-0.6-4.3-3.4-3.6-6.2c0.6-2.8,3.4-4.3,6.2-3.6c2.8,0.6,4.3,3.4,3.6,6.2C68.3,85.8,65.5,87.5,62.7,86.7z M67,103.4l1.3-11.5 c0.2-2.4,2.6-4.1,4.9-3.4l10.9,2.4C80.9,97.6,74.3,102.5,67,103.4z M85.4,86.3l-10.7-4.5c-2.1-0.9-3.2-3.4-2.1-5.3L77.7,65 C83.9,69.8,87.1,77.9,85.4,86.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099660654731068854230000013465042330874781630_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.4778,
    y1: 938.35,
    x2: 96.7287,
    y2: 938.35,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F46B45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#F7AA46"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099660654731068854230000013465042330874781630_)"
    },
    d: "M91.4,85.6l4.5,1.1l0.9-7.5L92,79 l-0.9-4.1l4.1-0.9l-2.8-7.5L89,68.4l-3-3.6l2.6-2.1l-4.5-4.9L81.3,61c-1.3-0.9-2.6-1.9-3.8-2.8l1.9-3.6l-6.2-2.4l-1.3,3.2 L67.4,54l0.6-3.8h-7.9l0.6,4.1l-4.1,0.6l-1.9-4.3L48.2,54l2.6,3.8L47,60.4l-2.6-3.8l-5.6,4.9l2.8,2.6l-2.8,4.1l-3.6-1.9 l-2.4,6.2l3.2,1.3l-0.9,5.1l-3.8-0.6l0.2,6.6l3.8,0.6l0.6,4.1l-3,2.1l3,5.8l2.4-1.5l2.6,3.8l-3,2.1l3.6,5.3L46,104 c1.1,0.9,2.4,1.7,3.4,2.6l-1.3,5.3l6.2,1.7l0.9-3.6l4.5,1.1l-0.6,2.8l6.4,0.6l0.9-3.6l4.1-0.9l1.9,3.4l6.2-2.1l-1.9-3.4l4.5-2.6 l2.1,2.6l4.9-4.5l-3.2-2.8l3-4.1l3.4,1.9l2.8-6.8l-4.5-1.1L91.4,85.6z M57.6,106.6c-13.7-3.4-21.8-17.3-18.4-31 c3.4-13.7,17.3-21.8,31-18.4s21.8,17.3,18.4,31S71.3,110,57.6,106.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090288398072443045880000011178007592506131642_",
    gradientUnits: "userSpaceOnUse",
    x1: -1899.5533,
    y1: 898.4166,
    x2: -1862.7775,
    y2: 898.4166,
    gradientTransform: "matrix(-1 0 0 1 -1833.5507 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3142,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6769,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090288398072443045880000011178007592506131642_)"
    },
    d: "M29.8,46.7c0,0.2,0,0.2,0,0.4 c0,0.4,0.2,0.6,0.4,1.1l0,0c2.4,7.1,8.5,12,15.6,12.4l0,0c0.4,0,0.6,0.2,1.1,0.2l0,0c1.7,0,3.4-0.2,5.1-0.6 c9.8-2.6,15.8-12.6,13.3-22.4c-0.9-3.6-3-6.6-5.6-9c-0.6-0.6-1.3-1.1-2.1-1.5l0,0c-4.1-3-9.6-4.1-15-2.6 c-1.9,0.4-3.8,1.3-5.6,2.4l0,0C31.3,31.3,27.9,39,29.8,46.7z M56.1,29.4l-5.8,6.2c-1.3,1.3-3.2,1.3-4.3,0l-5.8-6.8 c1.1-0.6,2.4-1.1,3.6-1.5C48.2,26.2,52.7,27.1,56.1,29.4z M62.9,46.3l-7.3-3.4c-1.5-0.6-2.1-2.6-1.3-4.1l4.5-7.5 c1.9,1.9,3.4,4.5,4.3,7.3C63.6,41.2,63.6,43.9,62.9,46.3z M48.6,58.3l1.7-9c0.4-1.7,1.9-2.8,3.6-2.4l7.9,2.1 c-1.9,4.1-5.6,7.3-10.3,8.5C50.5,58,49.7,58,48.6,58.3z M44.1,43.3c-0.4-1.9,0.6-4.1,2.6-4.5c1.9-0.4,4.1,0.6,4.5,2.6 c0.4,1.9-0.6,4.1-2.6,4.5C46.5,46.5,44.5,45.4,44.1,43.3z M33.2,48.9l7.9-1.7c1.7-0.4,3.2,0.9,3.4,2.6l1.1,8.3 C40.1,57.4,35.4,53.8,33.2,48.9z M37.7,30.3l3.8,8.3c0.6,1.5,0,3.2-1.5,3.8l-7.7,3.2C31.1,39.7,33.2,33.9,37.7,30.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000199332091488096840000007732538671051515532_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.2719,
    y1: 898.55,
    x2: 49.9531,
    y2: 898.55,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3142,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6769,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000199332091488096840000007732538671051515532_)"
    },
    d: "M47.1,40.3c1.3-0.4,2.6,0.4,2.8,1.7 c0.4,1.3-0.4,2.6-1.7,2.8c-1.3,0.4-2.6-0.4-2.8-1.7C45,41.8,45.8,40.5,47.1,40.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098210380485300959800000008820281036748250756_",
    gradientUnits: "userSpaceOnUse",
    x1: -1904.6671,
    y1: 898.75,
    x2: -1857.5565,
    y2: 898.75,
    gradientTransform: "matrix(-1 0 0 1 -1833.5507 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5AEDC8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098210380485300959800000008820281036748250756_)"
    },
    d: "M28.7,48.4l-3.2,0.9l1.9,4.9l2.4-1.3 l2.1,3l-2.4,1.9l3.6,3.2l1.7-1.7l3.2,1.9l-1.5,2.4l4.5,1.5l1.5-2.4l3,0.6l0.6,2.6l4.7-0.4l-0.4-1.9l3.2-0.9l0.6,2.6l4.5-1.1 l-1.1-3.8c0.9-0.6,1.7-1.3,2.6-1.9l3.2,2.4l2.6-3.8l-2-1.6l1.9-2.8l1.7,1.1l2.1-4.3L67.6,48l0.4-3l2.8-0.4v-4.9L68,40.1l-0.6-3.6 l2.1-0.9l-1.7-4.5l-2.6,1.5l-1.9-3l2.1-1.7l-4.1-3.6l-1.9,2.8l-2.8-1.9l1.9-2.8L54,19.8L52.7,23l-3-0.4l0.4-3h-5.8l0.4,2.8 l-3.2,1.1l-0.9-2.1L36.2,23l1.5,2.6c-0.9,0.6-1.7,1.3-2.8,2.1L33,25.3L29.8,29l1.7,1.7l-2.1,2.6L27,31.8l-2.1,5.3l3,0.6l-0.6,3 l-3.4,0.2l0.6,5.3l3.2-0.9L28.7,48.4z M29.8,47.1c-2.6-9.8,3.4-19.9,13.3-22.4C52.9,22.1,63,28.1,65.5,38 c2.6,9.8-3.4,19.9-13.3,22.4C42.4,62.7,32.4,57,29.8,47.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110435412263933961130000010603505115478260640_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.0917,
    y1: 949.7286,
    x2: 135.1611,
    y2: 880.4479,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000110435412263933961130000010603505115478260640_)"
    },
    cx: 97.9,
    cy: 59.3,
    r: 50.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 97.9,
    cy: 59.3,
    rx: 44.9,
    ry: 44.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088119314785186955100000012455848920478933417_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.5485,
    y1: 915.3,
    x2: 137.5095,
    y2: 915.3,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000088119314785186955100000012455848920478933417_)"
    },
    cx: 97.9,
    cy: 59.3,
    r: 7.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173842291478192886350000008826124143271444882_",
    gradientUnits: "userSpaceOnUse",
    x1: 994.2476,
    y1: -983.1427,
    x2: 1071.1869,
    y2: -983.1427,
    gradientTransform: "matrix(-0.7014 -0.7128 0.7128 -0.7014 1518.8594 111.5156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173842291478192886350000008826124143271444882_)"
    },
    d: "M100.9,50.1c0,0.2,0,0.4,0,0.4 l-8.8,33.3c-0.2,0.4-0.6,0.6-1.1,0.6c-0.4-0.2-0.6-0.6-0.6-1.1L99.2,50c0.2-0.4,0.6-0.6,1.1-0.6 C100.7,49.7,100.7,49.9,100.9,50.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085934653578021548970000003768709118296457399_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.5485,
    y1: 912.15,
    x2: 137.5095,
    y2: 912.15,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085934653578021548970000003768709118296457399_)"
    },
    d: "M88.7,61.9c-0.2,0-0.4-0.2-0.4-0.6 s0.2-0.9,0.6-0.9l44.5-10c0.4,0,0.9,0.2,0.9,0.6s-0.2,0.9-0.6,0.9l-44.5,10C88.9,61.9,88.7,61.9,88.7,61.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.1,63.8c0,0.6-0.4,1.1-1.1,1.1h-3.2c-0.6,0-1.1-0.4-1.1-1.1v-2.6h1.7v2.1h2.1v-2.8l-1.9-1.3v-0.4l1.9-1.3v-2.4 h-2.1V57h-1.7v-2.4c0-0.6,0.4-1.1,1.1-1.1h3.4c0.6,0,1.1,0.4,1.1,1.1v2.6c0,0.4-0.2,0.9-0.6,1.1l-1.1,0.6l1.1,0.6 c0.4,0.2,0.4,0.6,0.4,1.1L136.1,63.8L136.1,63.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.9,98c0,0.6-0.4,1.1-1.1,1.1h-3.4c-0.6,0-1.1-0.4-1.1-1.1v-9c0-0.6,0.4-1.1,1.1-1.1h3.2c0.6,0,1.1,0.4,1.1,1.1v2.4 H99v-1.9h-2.1v3.2h2.8c0.6,0,1.1,0.4,1.1,1.1L100.9,98L100.9,98L100.9,98z M99.2,97.5v-3.4H97v3.4H99.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,63.8c0,0.6-0.4,1.1-1.1,1.1h-3.2c-0.6,0-1.1-0.4-1.1-1.1v-2.4h1.7v1.9h2.1v-3.2h-2.8c-0.6,0-1.1-0.4-1.1-1.1 v-4.3c0-0.6,0.4-1.1,1.1-1.1h3.4c0.6,0,1.1,0.4,1.1,1.1L64.1,63.8L64.1,63.8L64.1,63.8z M62.4,58.6v-3.4h-2.1v3.4H62.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,28.5h-1.7v-7.7h-0.6v-0.2l0.9-3h1.3L96,28.5L96,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4,20.6c0,0.4-0.2,0.6-0.4,1.1L99,27h3.4v1.5H97v-1.1l3.6-6.4v-1.9h-1.9v2.1h-1.5v-2.4c0-0.6,0.4-1.1,1.1-1.1h3.2 c0.6,0,1.1,0.4,1.1,1.1v1.7L102.4,20.6L102.4,20.6L102.4,20.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134960959435672888040000005502049174115796387_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.4503,
    y1: 946.3,
    x2: 81.7066,
    y2: 946.3,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134960959435672888040000005502049174115796387_)"
    },
    points: "81.6,86.2 81.2,86 79.1,88.6  75.4,93.1 76.7,93.9 78,94.6 80.4,89.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061469580528979097840000014598438759123757247_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.7,
    y1: 932.7,
    x2: 69.6223,
    y2: 932.7,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000061469580528979097840000014598438759123757247_)"
    },
    points: "69.7,74.5 69.5,73.8 66,75.1  60.7,77 61.3,78.3 62,79.6 66.7,76.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073690861026234829220000013269518115795334288_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.1747,
    y1: 947,
    x2: 119.431,
    y2: 947,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000073690861026234829220000013269518115795334288_)"
    },
    points: "113.3,86.9 113.7,86.6  115.8,89.4 119.5,93.9 118.2,94.6 116.9,95.4 114.5,90.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066492163844851232150000013537383616621508515_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.2505,
    y1: 933.55,
    x2: 134.1729,
    y2: 933.55,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000066492163844851232150000013537383616621508515_)"
    },
    points: "125.2,75.1 125.4,74.7  128.9,75.7 134.2,77.7 133.6,78.9 132.7,80.4 128.2,77  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101066549683323100490000007986497083093421224_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.8131,
    y1: 882.15,
    x2: 120.0696,
    y2: 882.15,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101066549683323100490000007986497083093421224_)"
    },
    points: "113.9,30.2 114.3,30.4  116.5,27.9 120.1,23.4 118.8,22.5 117.5,21.9 115.2,27  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176036155884184083320000016939361049936105111_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.8889,
    y1: 895.7,
    x2: 134.8112,
    y2: 895.7,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000176036155884184083320000016939361049936105111_)"
    },
    points: "125.9,42 126.1,42.6  129.5,41.3 134.9,39.4 134.2,38.1 133.4,36.8 128.7,40.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152983840774826278420000010941002866970271419_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.0889,
    y1: 881.4,
    x2: 82.3452,
    y2: 881.4,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152983840774826278420000010941002866970271419_)"
    },
    points: "82.3,29.4 81.8,29.8 79.7,27  76.1,22.5 77.4,21.9 78.6,21 81,26.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100340215737498906930000008152300865836101271_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.3471,
    y1: 894.9,
    x2: 70.2694,
    y2: 894.9,
    gradientTransform: "matrix(1 0 0 1 0 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000100340215737498906930000008152300865836101271_)"
    },
    points: "70.3,41.3 70.1,41.8  66.7,40.7 61.3,38.8 62,37.3 62.6,36 67.3,39.2  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M99.6,59.3c0,1.1-0.9,1.7-1.7,1.7c-1.1,0-1.7-0.9-1.7-1.7c0-1.1,0.9-1.7,1.7-1.7 C98.7,57.4,99.6,58.2,99.6,59.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141"
    },
    d: "M261.4,265.3c2.8,1.4,10.4-1.5,10.4-1.5s0.3,3.1-1,4s-15.2,0.4-15.9-1.5c-0.3-0.8,1.9-1.9,4.5-2.7 C259.7,264.1,260.3,264.7,261.4,265.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BEC1"
    },
    d: "M264,262.7c-1.6,0.5-3.2,0.8-4.6,1.1c0.2,0.5,0.8,1.1,1.9,1.7c4.6,2.2,10.1-1.3,10.4-1.5 c0.1-0.5,0.2-1.2,0.3-1.9l-5.4-0.3C265.8,262.1,264.9,262.4,264,262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BEC1"
    },
    d: "M330.4,265.4c2.1-0.4,4.2-0.7,6.3-1.1c-0.2-0.4-0.3-0.9-0.5-1.4c-0.1-0.5-0.2-1-0.3-1.4 c-2,0.5-3.9,0.9-5.9,1.4C330.1,263.7,330.2,264.5,330.4,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#30302F"
    },
    d: "M331.4,268.5c1.8-0.1,3.7-0.3,5.5-0.4c0.2-0.6,0.3-1.7,0.1-2.9c-0.1-0.8-0.4-1.4-0.6-1.9h-0.5 c-1.7-0.1-2.5-0.2-2.6-0.2c-0.5,0.1-0.4,0.2-2.6,1c-0.2,0.1-0.4,0.1-0.5,0.2c-0.1,0.5-0.1,1.5,0.3,2.6 C330.7,267.6,331.1,268.2,331.4,268.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054970024312327636580000018146951562836702604_",
    gradientUnits: "userSpaceOnUse",
    x1: -1617.6622,
    y1: 1052.5983,
    x2: -1584.2803,
    y2: 1127.2683,
    gradientTransform: "matrix(1 0 0 1 1895.7638 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#A26581"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#8C607F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#7E5D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054970024312327636580000018146951562836702604_)"
    },
    d: "M304.8,163.3c1.5,3.6,2.9,7.3,4.3,11.1 c7.1,19.2,10.5,32.9,14,45.8c2.8,10,7,24.3,13,41.7c-2.1,0.3-4.1,0.7-6.2,1c-8.4-13.2-16.8-27.1-25.1-41.9c-4.5-8-8.8-16-12.9-23.8 c-1.4,3.9-2.8,7.9-4.5,12.1c-2.2,5.6-4.5,10.8-6.8,15.8c-2.8,12.5-5.6,25-8.4,37.4c-2.1-0.1-4.3-0.3-6.4-0.4 c-1-11.4-1.3-24.8,0.2-39.8c2.3-24.3,8.4-44.3,14.2-59.1C288.5,163.3,296.6,163.3,304.8,163.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076600988299126957050000010191414071115480226_",
    gradientUnits: "userSpaceOnUse",
    x1: -1628.0674,
    y1: 1115.9927,
    x2: -1602.5917,
    y2: 1021.9963,
    gradientTransform: "matrix(1 0 0 1 1895.7638 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#A26581"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#8C607F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#7E5D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076600988299126957050000010191414071115480226_)"
    },
    d: "M304.5,163.3c-8.1,0-16.1,0-24.2,0 c-5.8,14.8-11.9,34.8-14.2,59.1c-1.5,15-1.2,28.4-0.2,39.8c2.1,0.1,4.3,0.3,6.4,0.4c2.8-12.5,5.6-25,8.4-37.4 c1.9-5,4.2-10.3,6.8-15.8c3.6-7.6,7.5-14.5,11.2-20.6c1.6-1.6,5.4-6,6.7-12.9C306.5,170.2,305.2,165.5,304.5,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BEC1"
    },
    d: "M262.8,105.1l0.1-0.1c0.1-0.2,0.2-0.6,0.5-1.9c0,0,0.2-0.8,0.3-2.6c0-0.3,0.1-0.7-0.2-0.9 c-0.1-0.1-0.4-0.2-0.5-0.1c-0.3,0.1-0.5,0.3-0.6,0.6c-0.2,0.7-0.3,1.4-0.5,2.2c0,0,0.4,2.4-0.2,3.6l0,0 C262.2,105.6,262.5,105.4,262.8,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BEC1"
    },
    d: "M262,102.1c-0.1-2.1-0.1-4.1-0.2-6.2c0-0.4-0.3-0.7-0.7-0.7c-0.3,0-0.6,0.3-0.6,0.6 c-0.1,1.1-0.1,2.3-0.2,3.4c-0.1-1.1-0.2-2.3-0.4-3.4c0-0.4-0.3-0.7-0.6-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,1.1,0,2.3,0,3.4 c-0.2-1.1-0.3-2.2-0.5-3.3c-0.1-0.3-0.4-0.6-0.7-0.6c-0.4,0-0.7,0.4-0.6,0.8c0.1,1.1,0.1,2.2,0.2,3.2c-0.1-1-0.3-2-0.4-3 c-0.1-0.2-0.4-0.4-0.7-0.3s-0.5,0.3-0.5,0.5c0.2,3.6,0.5,6.3,0.6,7.3c0,0.2,0.1,0.7,0.4,1.2s0.7,0.8,0.9,0.9c0,0.5,0,1.1,0,1.6 c1.3,0.1,2.6,0.1,3.8,0.2c-0.1-0.7-0.1-1.4-0.2-2.1c0.2,0,0.5-0.1,0.8-0.2l0,0C262.3,104.5,262,102.1,262,102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BEC1"
    },
    d: "M317.3,186.4c0.2,0.1,0.4,0,0.5-0.1c0.2-0.2,0.3-0.5,0.3-0.8c-0.1-0.7-0.3-1.4-0.4-2.2 c0.9,1.9,1.8,3.7,2.7,5.6c0.2,0.3,0.6,0.5,0.9,0.3c0.3-0.1,0.4-0.5,0.3-0.8c-0.4-1.1-0.8-2.1-1.2-3.2c0.6,1,1.2,2,1.7,3 c0.1,0.3,0.5,0.5,0.8,0.4c0.4-0.1,0.6-0.6,0.4-0.9c-0.5-1-1-2.1-1.4-3.1c0.6,0.9,1.2,1.9,1.8,2.8c0.2,0.3,0.6,0.4,0.9,0.2 s0.5-0.6,0.2-1c-0.5-1-1-1.9-1.5-2.9c0.5,0.9,1.1,1.7,1.6,2.6c0.2,0.2,0.5,0.1,0.8,0c0.2-0.2,0.3-0.4,0.3-0.7 c-1.7-3.2-3.1-5.6-3.6-6.4c-0.1-0.2-0.4-0.6-0.9-0.9c-0.5-0.3-0.9-0.4-1.2-0.4c-0.2-0.5-0.4-1-0.7-1.5c-1.2,0.5-2.4,0.9-3.6,1.4 c0.3,0.6,0.7,1.2,1,1.8c-0.2,0.1-0.4,0.3-0.6,0.5c-0.3,0.3-0.6,0.6-0.7,1.1c0,0,0,0.1,0,0.2c0,0.3,0,0.6,0.3,1.9 c0,0,0.2,0.8,0.8,2.5C316.9,185.9,317,186.3,317.3,186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BEC1"
    },
    d: "M288.3,127.7c-0.1,2-0.2,4.1-0.4,6.1l0,0c-0.8,2.1-0.2,4.3,1.1,5.2c2.1,1.4,5.1-0.7,5.5-1 c1.3-0.9,1.9-2.1,2.2-2.8c-0.4-0.8-0.8-1.7-1.2-2.7c-1.1-2.9-1.5-5.6-1.6-7.7C292.1,125.8,290.2,126.7,288.3,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F09DA3"
    },
    d: "M294.3,127.6c-2,0.4-4,0.8-6,1.3c0,0,0,0,0,0.1c0,0.4,0,0.7-0.1,1.1c1.7,0.4,3,0.4,3.8,0.3 c0.8-0.1,1.3-0.2,1.7-0.6c0.5-0.5,0.7-1.1,0.8-1.4C294.4,128.1,294.3,127.9,294.3,127.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111176507118608009790000005659097707904535975_",
    gradientUnits: "userSpaceOnUse",
    x1: -3192.1082,
    y1: 982.05,
    x2: -3159.7173,
    y2: 982.05,
    gradientTransform: "matrix(1 0 0 1 3447.3735 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7BCAB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4953,
    style: {
      stopColor: "#71C9C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC8C7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111176507118608009790000005659097707904535975_)"
    },
    d: "M287.7,132.9c-1.2,2.5-2.7,5.1-4.5,7.8 c-1.1,1.7-2.2,3.3-3.3,4.8c-5.3-2-11.8-5.1-17.3-9.5c-1.5-1.2-2.9-2.4-4.1-4.3c-1.2-1.8-2.4-4.4-2.9-10.5 c-0.3-3.5-0.5-8.5,0.4-14.6c2.1,0,4.2,0,6.2,0c2,5.8,4.1,11.7,6.1,17.5c2.5,2.1,6.3,4.7,11.3,6.6 C282.6,131.9,285.3,132.6,287.7,132.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000225003042139991050000012590505916282810293_",
    gradientUnits: "userSpaceOnUse",
    x1: -3152.2212,
    y1: 1012.25,
    x2: -3126.751,
    y2: 1012.25,
    gradientTransform: "matrix(1 0 0 1 3447.3735 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7BCAB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4953,
    style: {
      stopColor: "#71C9C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC8C7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000225003042139991050000012590505916282810293_)"
    },
    d: "M295.2,143.3c3.4-1,5.8-3.5,6.3-6.5 c0.3-1.7-0.2-3.1-0.6-3.9c2.2,0.3,5.4,1.2,8.3,3.5c3.4,2.7,5.4,6.5,8.2,20c1.1,5.2,2.3,12.1,3.2,20.3c-1.7,1-3.4,1.9-5.1,2.9 c-4.2-10.1-8.5-20.3-12.7-30.4C300.2,147.3,297.7,145.3,295.2,143.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165957576117229198000000014318943612822680249_",
    gradientUnits: "userSpaceOnUse",
    x1: -3168.5735,
    y1: 1004.1109,
    x2: -3144.8735,
    y2: 1004.1109,
    gradientTransform: "matrix(1 0 0 1 3447.3735 -856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7BCAB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4953,
    style: {
      stopColor: "#71C9C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC8C7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165957576117229198000000014318943612822680249_)"
    },
    d: "M302.5,133.5c-2-0.3-4.1-0.5-6.4-0.7 c-2.8-0.2-5.5-0.2-7.9-0.1c-1.9-0.3-3.8-0.6-5.7-0.9c-0.8,2.3-1.6,4.8-2.3,7.5c-0.5,2-1,3.9-1.4,5.7c0.4,6.3,0.7,12.6,1.1,18.9 c3.2,0.4,7,0.7,11.3,0.4c3.3-0.2,6.2-0.6,8.8-1.1C300.8,153.4,301.7,143.4,302.5,133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BB6454"
    },
    d: "M292.2,110.4c2.4-1.3,4.6-1.3,5.5-1.3c5.2,0,9,3.6,9.8,4.3c8.3,8.1-3.6,21,3.7,37.9 c1.6,3.6,4.6,9,3,15c-0.3,1.2-1.1,3.7-3.2,5.3c-4.2,3.1-12.1,1.5-16.3-2.7c-7-7-5.6-23.1-2.4-32.6c0.9-2.6,3.1-8.5,1.4-9.7 c-1.2-0.8-3,1.4-4.8,0.6c-2.8-1.2-3.3-8.6-0.3-13.3C289.9,111.7,291.8,110.6,292.2,110.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BEC1"
    },
    d: "M291.3,114.3c-2,0.5-6.8,10.5-6.9,12.1s2.6,2.4,4.3,3c1.6,0.6,4.2,0.1,4.8-0.2 c0.6-0.4,1.2-2.4,1.2-2.4s1.1,1.3,1.8,0.1c0.7-1.2,0.8-3.6-0.1-3.1c-0.8,0.5-0.8,0.5-0.8,0.5S293.6,113.7,291.3,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.9,124.9c0.8,0.2,1.7-0.2,2.1-1l0,0l-1.4-0.7C285.3,123.8,285.1,124.4,284.9,124.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6a232cd9.svg";
export { ForwardRef as ReactComponent };